import "./App.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">Dictionary App</header>
        <main>
          <Dictionary defaultKeyWord="Sunset" />
        </main>

        <footer className="footer">Coded by Neda.Gh.T</footer>
      </div>
    </div>
  );
}

export default App;
